/* import __COLOCATED_TEMPLATE__ from './assign.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type RouterService from '@ember/routing/router-service';

interface Signature {
  Args: {
    onNext?: () => void;
  };
}

export default class AssignComponent extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare router: RouterService;

  get salesforceConfig() {
    return this.finStandaloneService.salesforcePlatform.salesforceConfig;
  }

  get finIdentityUrl() {
    return this.router.urlFor('apps.app.standalone.deploy.salesforce.cases.connect', {
      queryParams: { section: 'fin-identity' },
    });
  }

  get caseRulesUrl() {
    return this.salesforceConfig?.buildLightningSetupUrl('CaseRules/home');
  }

  get flowsUrl() {
    // eslint-disable-next-line @intercom/intercom/no-bare-strings
    return this.salesforceConfig?.buildLightningSetupUrl('Flows/home');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Cases::Assign': typeof AssignComponent;
  }
}
